module.exports = "<section>\r\n    <h2>{{projTitle}}</h2>\r\n    <p>{{projDesc}}<p>\r\n</section>\r\n"